import { render, staticRenderFns } from "./SdsDataTable.vue?vue&type=template&id=4209f6fa"
import script from "./SdsDataTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsDataTable.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports